import { doc, onSnapshot } from "firebase/firestore";
import { toNumber } from "lodash";
import { useEffect } from "react";
import { db } from "../../firebaseConfig";
import { hasPendingReleaseLogin } from "./pendingReleaseLogin";
import { hasPendingSmsLogin } from "./pendingSmsLogin";

let reloadDeferred = false;

/** Runs a version reload that arrived while the patient was in the SMS login or a practice release's steps. */
export const reloadIfDeferred = () => {
  if (reloadDeferred) window.location.reload();
};

export const useUpdateApp = () => {
  const localVersion = import.meta.env.VITE_VERSION;
  useEffect(() => {
    if (!localVersion) return;
    const subscription = onSnapshot(
      doc(db, "appInfo/patientWebapp"),
      (snapshot) => {
        const data = snapshot?.data() as {
          version: string;
          versionBeta: string;
        };
        const webVersion =
          import.meta.env.VITE_IS_BETA === "true"
            ? data?.versionBeta
            : data?.version;
        if (!webVersion) return;
        const [major, minor, patch] = webVersion
          ? webVersion.split(".").map((e) => toNumber(e))
          : [];
        const [currentMajor, currentMinor, currentPatch] =
          import.meta.env.VITE_VERSION.split(".").map((e) => toNumber(e));
        const isNewerVersion =
          major > currentMajor ||
          (major === currentMajor && minor > currentMinor) ||
          (major === currentMajor &&
            minor === currentMinor &&
            patch > currentPatch);
        if (isNewerVersion) {
          // A reload now would cost what the patient is typing, and on the SMS path a new SMS.
          if (hasPendingSmsLogin() || hasPendingReleaseLogin()) {
            reloadDeferred = true;
            return;
          }
          alert("Neue Version verfügbar. Seite wird neu geladen.");
          window.location.reload();
        }
      },
      (error) => console.error("Version listener failed:", error),
    );
    return () => subscription();
  }, [localVersion]);
};
